/** Media queries as React state, for layouts that differ by more than CSS can say. */
import { useSyncExternalStore } from "react";

function media(query: string) {
  const mql = typeof window === "undefined" ? null : window.matchMedia(query);
  return {
    subscribe(cb: () => void) {
      mql?.addEventListener("change", cb);
      return () => mql?.removeEventListener("change", cb);
    },
    get: () => !!mql?.matches,
  };
}

/** Below the `md` breakpoint, where the sidebar becomes a drawer. */
const phone = media("(max-width: 767px)");
export const useIsPhone = () => useSyncExternalStore(phone.subscribe, phone.get);
export const isPhone = phone.get;
